<template>
    <div class="skill_state_category">
        <div class="skill_state_content_div">
            <div class="skill_state_left_div">
                <TargetState></TargetState>
            </div>
            <div class="skill_state_right_div">
                <TargetLink></TargetLink>
            </div>
        </div>
        <hr/>
        <v-loader :source="courses_content" :urls="['/api/v2/courses']">
            <div class="courses_div">
                <CourseCard
                    class="courses_selection_course_card"
                    v-for="(course_info, index) in courses_content['results']"
                    :key="index"
                    :data="course_info"
                >

                </CourseCard>
            </div>
        </v-loader>
        <TabPage :change_current_page="change_current_page"
                 :showing_page_info="showing_page_info"
                 :current_page="current_page"
                 :all_page="all_page"
        >
        </TabPage>
    </div>

</template>
<script type="text/javascript">
import TargetState from '@/components/eval_page/target_state.vue'
import TargetLink from '@/components/eval_page/target_link.vue'
import CourseCard from '@/components/common_components/cards/course_card.vue'
import TabPage from '@/components/common_components/tab_page/tab_page_with_pager.vue'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    components: {
        TargetState,
        TargetLink,
        CourseCard,
        TabPage
    },
    computed: {
        ...mapState({
            current_category: state => state.coursesCategory.current_category,
            current_tag: state => state.coursesCategory.current_tag,
            current_classify: state => state.coursesCategory.current_classify,
            current_base_order: state => state.coursesCategory.current_base_order,
            current_category_order: state => state.coursesCategory.current_category_order,
            current_type_order: state => state.coursesCategory.current_type_order,
            courses_content: state => state.coursesCategory.courses_content_skill,
            courses_category: state => state.coursesCategory.courses_category,
            current_page: state => state.coursesCategory.current_page_skill,
            all_page: state => state.coursesCategory.all_page_skill
        }),
        ...mapGetters({
            showing_page_info: 'coursesCategory/showing_page_info_skill'
        })
    },
    methods: {
        ...mapActions({
            get_course_content_for_skill_state:'coursesCategory/get_course_content_for_position_target',
            change_current_category: 'coursesCategory/change_current_category',
            change_current_classify: 'coursesCategory/change_current_classify',
            change_current_tag: 'coursesCategory/change_current_tag',
            change_current_base_order: 'coursesCategory/change_current_base_order',
            change_current_category_order: 'coursesCategory/change_current_category_order',
            change_current_type_order: 'coursesCategory/change_current_type_order',
            change_current_page: 'coursesCategory/change_current_page_for_position_target'
        })
    },
    watch: {
        '$route': function () {
            this.get_course_content_for_skill_state(this.$route.query)
        }
    },
    mounted: function () {
        this.get_course_content_for_skill_state(this.$route.query)
    }
}



</script>
<style type="text/css">
.skill_state_category {
    width: 1170px;
    padding: 0 5px;
    margin-left: auto;
    margin-right: auto;
}
.courses_div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
}
.courses_selection_course_card {
    width: 25%;
    margin: 0 0 20px;
    padding: 0 15px;
}
    .skill_state_content_div{
        display: flex;
    }
    .skill_state_left_div{
        width: 80%;
        padding: 10px 15px;
        background: #fff;
    }
    .skill_state_right_div{
        width: 20%;
        padding: 10px 15px;
        background: #fff;
    }
</style>

